import axios from 'axios'
import { RESERVAS_SOLICITADO_REEMBOLSO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function solicitarReembolso (empresaId, motivo, reservas) {
  const url = `${URL}/reserva/solicitar-reembolso`;
  return dispatch => axios.post(url,{ empresaId, motivo,  reservas} , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: RESERVAS_SOLICITADO_REEMBOLSO,
        payload: response
      })
  );
}
